import { StockModel } from '@/http/models/Stock/Stock'

import { UseFetchListForm, useFetchList } from '@/hooks/useFetchList'

import { StockHttpParams, StockTransactionModel } from '@/types'

export interface StockHistoryFilters {
  type: StockHttpParams.GetHistory['query']['type'] | null
  status: StockHttpParams.GetHistory['query']['status'] | null
}

export interface StockHistoryListForm
  extends UseFetchListForm<StockHistoryFilters, StockTransactionModel.StockTransaction> {}

const initialFilters: StockHistoryFilters = {
  type: null,
  status: null,
}

interface Props {
  shouldFetchList?: boolean
}

export const useFetchStockHistory = ({ shouldFetchList = true }: Props = {}) => {
  return useFetchList<
    StockHistoryFilters,
    StockTransactionModel.StockTransaction,
    {},
    any,
    typeof StockModel.getHistory
  >({
    pageSize: 10,
    initialFilters,
    fetchFunction: StockModel.getHistory,
    register: shouldFetchList,
    buildQueryParams: (filters): StockHttpParams.GetHistory['query'] => ({
      type: filters.type || undefined,
      status: filters.status || undefined,
    }),
    buildParams: () => ({}),
  })
}
